import React from "react";
import { Row, Col, Form } from "react-bootstrap";
const AccountType =()=>{
    return(
        <Form
                method="post"
                id="safariform"
                action="/account/default/registration-operator"
                enctype="multipart/form-data"
              >
                <Col md={6} className="typeaccount">
                  <div className="mb-3 field-safaritourregistrationform-account_type">
                    <Form.Label>Account Type</Form.Label>
                    <div
                      id="safaritourregistrationform-account_type"
                      role="radiogroup"
                    >
                      <Form.Check>
                        <input
                          type="radio"
                          name="SafaritourRegistrationForm[account_type]"
                          id="i0"
                          value={1}
                          className="form-check-input"
                        />
                        <Form.Label className="form-check-label" id="i0">
                          Traveller
                        </Form.Label>
                      </Form.Check>
                      <Form.Check>
                        <input
                          type="radio"
                          name="SafaritourRegistrationForm[account_type]"
                          id="i1"
                          value={2}
                          className="form-check-input"
                        />
                        <Form.Label className="form-check-label" id="i1">
                          Wildlife Influencer
                        </Form.Label>
                      </Form.Check>
                      <Form.Check>
                        <input
                          type="radio"
                          name="SafaritourRegistrationForm[account_type]"
                          id="i2"
                          value={3}
                          className="form-check-input"
                        />
                        <Form.Label className="form-check-label" id="i2">
                          Safari Operator
                        </Form.Label>
                      </Form.Check>
                    </div>
                  </div>
                </Col>
              </Form>
    )
}

export default AccountType